import {Repository} from './Repository';

export default class UserStudyRepository extends Repository {
    constructor() {
        super();

        this.userStudyRequestPrefix = '/api/v1';
    }

    getUserStudyStatistics = (localeGroupId, year, month) => {
        const params = new URLSearchParams({localeGroupId});
        if (year) {
            params.append('year', year);
        }
        if (month) {
            params.append('month', month);
        }
        return this.getRequestPromise('get', `${this.userStudyRequestPrefix}/statistics?${params.toString()}`);
    };

    recalculateUserStudyStatistics = (localeGroupId, year, month) => {
        const params = new URLSearchParams({localeGroupId});
        if (year) {
            params.append('year', year);
        }
        if (month) {
            params.append('month', month);
        }
        return this.getRequestPromise('post', `${this.userStudyRequestPrefix}/statistics/recalculate?${params.toString()}`);
    };

    getStatisticMonths = (localeGroupId) => {
        return this.getRequestPromise('get', `${this.userStudyRequestPrefix}/statistics/months?localeGroupId=${localeGroupId}`);
    };
}
